import { apiClient } from './client';
import type {
  User,
  UserListItem,
  CreateUserRequest,
  UpdatePasswordRequest,
  UpdateAdminStatusRequest
} from '../types';

export const usersApi = {
  /**
   * Get all users (admin only)
   */
  async getAllUsers(): Promise<UserListItem[]> {
    return apiClient.get<UserListItem[]>('/api/users');
  },

  /**
   * Create a new user (admin only)
   */
  async createUser(data: CreateUserRequest): Promise<User> {
    return apiClient.post<User>('/api/users', data);
  },

  /**
   * Update user password (admin only)
   */
  async updatePassword(userId: number, data: UpdatePasswordRequest): Promise<{ success: boolean }> {
    return apiClient.patch<{ success: boolean }>(`/api/users/${userId}/password`, data);
  },

  /**
   * Update user admin status (admin only)
   */
  async updateAdminStatus(userId: number, data: UpdateAdminStatusRequest): Promise<User> {
    return apiClient.patch<User>(`/api/users/${userId}/admin`, data);
  },

  /**
   * Delete a user (admin only)
   */
  async deleteUser(userId: number): Promise<{ success: boolean }> {
    return apiClient.delete<{ success: boolean }>(`/api/users/${userId}`);
  },
};
